import { LegacyUserDetailsModalComponent } from './../../components/rn-business-components/sidebar/legacy-user-details-modal/legacy-user-details-modal.component';
import { Injectable, inject } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { RnUsersVM } from "../rnapi2-service/models/models";
import { UserKeepDropPackageDialogComponent } from "../../components/rn-business-components/user-keep-drop-package-dialog/user-keep-drop-package-dialog.component";
import { DialogTrackingService } from "./dialog-tracking.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class RnDialogService {
  private dialogService = inject(DialogService);
  private dialogTrackingService = inject(DialogTrackingService);
  private dialog = inject(MatDialog);

  
public PreviousPackageActionDialog(
    selectedUsersWithPackage: RnUsersVM[],
    mode = "",
    isPurchasable: string,
    showDeleteUserText = true,
  ): DynamicDialogRef {
    const dialog = this.dialogService.open(UserKeepDropPackageDialogComponent, {
      header: "",
      width: "600px",
      contentStyle: { overflow: "auto" },
      baseZIndex: 800200,
      closable: false,
      showHeader: false,
      data: {
        isPurchasable: isPurchasable,
        showDeleteUserText: showDeleteUserText,
        mode: mode,
        users: selectedUsersWithPackage,
        packageTypes: selectedUsersWithPackage.reduce((r, a) => {
          for (const b of a.DirectBilledPackages) {
            if (!r[b]) {
              r[b] = [a.UserID];
            } else {
              r[b].push(a.UserID);
            }
          }
          return r;
        }, {}),
        totalPackages: selectedUsersWithPackage
          .filter((p) => p.DirectBilledPackages.length)
          .reduce((r, a) => r + a.DirectBilledPackages.length, 0),
      },
    });
    this.dialogTrackingService.addDialog(dialog);
    return dialog;
  }

  public EditUserProfileDialog(userId: number, orgId: number, title: string = ''): MatDialogRef<LegacyUserDetailsModalComponent> {
    const dialogData = {
      UserID: userId,
      OrganizationID: orgId,
      Title: title
    };
    const config = {
      header: "",
      width: "500px",
      contentStyle: { overflow: "auto" },
      baseZIndex: 10000,
      height: "auto",
      "z-index": 2000,
      closable: false,
      showHeader: false,
      disableClose: true,
      data: dialogData
    };

    return this.dialog.open(LegacyUserDetailsModalComponent, config);
  }
}
